export default __webpack_public_path__ + "static/media/bihada-factory-profile-hiaru.72ce67a6.png";